
export const scaleSmaller = ({ scale, offset: [xOffset, yOffset] }) => {
    scale /= 1.25
    xOffset /= 1.25
    yOffset /= 1.25
    xOffset += window.innerWidth / 10
    yOffset += window.innerHeight / 10

    return {
        scale,
        offset: [xOffset, yOffset]
    }
}

export const scaleBigger = ({ scale, offset: [xOffset, yOffset] }) => {
    scale *= 1.25
    xOffset -= window.innerWidth / 10
    yOffset -= window.innerHeight / 10
    xOffset *= 1.25
    yOffset *= 1.25

    return {
        scale,
        offset: [xOffset, yOffset]
    }
}
